/** Minimal copyright line for cover/footer */
export const IP_NOTICE_MINIMAL = "© Atlas PHM. Independently developed software.";

/** Short IP notice for print document footers (calmer, less defensive) */
export const IP_NOTICE_SHORT =
  "Atlas PHM is independently developed software. All outputs are provided for guidance purposes.";

/** Full IP notice for legal page only */
export const IP_NOTICE_LONG = `Atlas PHM and all associated software, models, calculations, outputs, and visualisations are original work and are owned exclusively by their creator.

This platform was developed independently, outside of any employer or third-party systems, and without the use of proprietary tools, datasets, training materials, or internal methodologies belonging to any current or former employer, partner, or commercial entity.

Any similarities to other industry tools or workflows arise solely from the application of publicly available standards, manufacturer documentation, and general engineering principles.

No rights, licence, ownership, or interest in this software or its outputs are granted or implied to any third party by use of this platform.`;
